import React, { FunctionComponent } from 'react';
import { useAsync } from 'react-async-hook';
import { ErrorMessage } from '../../../ErrorMessage/ErrorMessage';
import { Spinner } from '../../../Spinner/Spinner';
import { SupportDealerList } from './SupportDealerList/SupportDealerList';
import { LaunchPadService } from '../../../../services/LaunchPadService';
import { User } from '../../../../types/userTypes';
import styles from '../../styles.module.scss';

type Props = {
  user: User;
};

export const SupportOverview: FunctionComponent<Props> = ({ user }) => {
  const dealers = useAsync(LaunchPadService.getLaunchpadDealers, []);

  return (
    <div className={styles.supportOverview}>
      <h1 className={styles.supportWelcome}>
        Welcome back{user?.firstName ? `, ${user?.firstName}` : ''}!
      </h1>
      {dealers.loading && <Spinner variant="fullscreen" />}
      {dealers.error && <ErrorMessage error={dealers.error} />}
      {dealers.result && <SupportDealerList dealers={dealers.result.data} />}
    </div>
  );
};
